/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, styled } from "@mui/material";
import { DocumentLink } from "components/Common/DocumentLink";
import { Title } from "components/Common/Title";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const Container = styled(Box)(({ theme }) => ({
  padding: 3,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Contents = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2),
  flexGrow: 1,
}));

const Attention = styled(Box)(({ theme }) => ({
  padding: "1rem",
}));

/**
 * Component of user guide screen
 * @return{FC} Component
 */
export const UserGuide: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Title title={t("AWVUI-MSG111")} />
      <Container>
        <Contents>
          <ul>
            <li>
              <DocumentLink
                name={t("AWVUI-MSG112")}
                url={`${process.env.PUBLIC_URL}/manual/ui_manual.pdf`}
              />
            </li>
            <li>
              <DocumentLink
                name={t("AWVUI-MSG113")}
                url={`${process.env.PUBLIC_URL}/manual/awv-ui_manual.pdf`}
              />
            </li>
          </ul>
        </Contents>
        <Attention>{t("AWVUI-MSG114")}</Attention>
      </Container>
    </>
  );
};
